import Error from '../../views/Error';
import LayoutAuth from '../../layouts/Auth';
import Login from '../../components/Auth/Login';
import Register from '../../components/Auth/Register';
import ForgotPassword from '@/components/Auth/ForgotPassword';
import Dashboard from '../../views/Dashboard';
import LayoutPrimary from '../../layouts/Primary';
import FieldMap from '../../views/Admin/FieldMap';
import MediaLibrary from '../../views/Admin/MediaLibrary/MediaLibrary';
import ResetPassword from '@/components/Auth/ResetPassword';
import Auth from '@/components/Auth/Common/Auth';

export default [
    {
        path: '/error',
        name: 'Error',
        component: Error,
        meta: {
            requiresAuth: false,
            layout: LayoutAuth,
        },
    },

    {
        path: '/field/map',
        name: 'FieldMap',
        component: FieldMap,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },

    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        meta: {
            layout: LayoutAuth,
        },

        children: [
            {
                path: '/',
                redirect: '/auth/login'
            },

            {
                path: '/auth/login',
                name: 'Login',
                component: Login,
                meta: {
                    requiresAuth: false,
                    layout: LayoutAuth,
                },
            },

            {
                path: '/auth/register',
                name: 'Register',
                component: Register,
                meta: {
                    requiresAuth: false,
                    layout: LayoutAuth,
                },
            },
            {
                path: '/auth/forgot-password',
                name: 'ForgotPassword',
                component: ForgotPassword,
                meta: {
                    requiresAuth: false,
                    layout: LayoutAuth,
                },
            },
            {
                path: '/auth/password/reset/:token',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    requiresAuth: false,
                    layout: LayoutAuth,
                },
            },
        ]
    },
    {
        path: '/login',
        redirect: '/auth/login'
    },
    {
        path: '/register',
        redirect: '/auth/register'
    },
    {
        path: '/forgot-password',
        redirect: '/auth/forgot-password'
    },
    {
        path: '/password/reset/:token',
        redirect: '/auth/password/reset/:token'
    },
    {
        path: '/',
        name: 'Default',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/home',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/media',
        name: 'MediaLibrary',
        component: MediaLibrary,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/media/index',
        name: 'MediaLibrary',
        component: MediaLibrary,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
